import type { AnyRoute } from '@tanstack/react-router';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

export const createNotebooksRoutes = <TParent extends AnyRoute>(
  parent: TParent
) => {
  const notebooksRoute = createRoute({
    path: '/notebooks',
    getParentRoute: () => parent,
    component: lazyRouteComponent(() => {
      return import('./pages/NotebooksPage');
    })
  });

  return [notebooksRoute];
};
